// extracted by mini-css-extract-plugin
module.exports = {"resourceStyle":"_1xvETd2-q8xBc1rzw6PhnP"};